import Stalls from "./Stalls"

export default Stalls;